import { render, staticRenderFns } from "./DACHBasketHardwareUpfront.vue?vue&type=template&id=63a7225e&"
import script from "./DACHBasketHardwareUpfront.vue?vue&type=script&lang=js&"
export * from "./DACHBasketHardwareUpfront.vue?vue&type=script&lang=js&"
import style0 from "./DACHBasketHardwareUpfront.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports